export default __webpack_public_path__ + "static/media/Category-Cognitive-transparent.b6fcf8a4.png";